module.exports = "pegasus_template/assets/email1-header-2.png";